export default function buildQueryString(query) {
  return Object.keys(query)
    .map((key) => `${key}=${query[key]}`)
    .join('&');
}
